// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_4e5f713ae4--avatar--ceW9Q","clickable":"_4e5f713ae4--clickable--jjxbB","company":"_4e5f713ae4--company--MXKHY"};